<script setup lang="ts">
    import { inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { DashboardAccess } from '@views/Dashboard/Dashboard.access';
    import RecentItemsItem from './RecentItemsItem.vue';
    import Loading from '@shared/components/Loading.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const dashboardAccess: DashboardAccess = injectorAccess.injector.get(DashboardAccess);
</script>

<template>
    <section>
        <h2 class="h4 m-0-t strong">{{ $Resources.DashboardLastModifiedItemsHeading }}</h2>

        <ul class="list-1 list-unstyled" v-if="dashboardAccess.state.lastModifiedItems.length">
            <li v-for="item in dashboardAccess.state.lastModifiedItems" :key="item.Url">
                <RecentItemsItem :item="item" />
            </li>
        </ul>

        <div class="alert alert-info alert-fixed-i" v-if="!dashboardAccess.state.lastModifiedItems.length && !dashboardAccess.state.loadingLastModifiedItems">
            <p>
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                {{ $Resources.NoDraftsMessage }}
            </p>
        </div>

        <Loading :show="dashboardAccess.state.loadingLastModifiedItems" loadingStyle="progress-bar" />
    </section>
</template>

<style scoped></style>
